var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"ln-header"},[_c('div',{staticClass:"w1200"},[_vm._v("辽宁朝阳点播系统")])])}]

export { render, staticRenderFns }